export class DictionaryEntry {
  public id?: number;
  public company_id?: number;
  public component: string;
  public sub_component: string;
  public value: string;
  public info: string;
  public nls_code: string;
  public user_insert: number;
  public user_update: number;
  public user_delete: number;
}



// WEBPACK FOOTER //
// ./src/app/models/dictionary.model.ts